import Curl from '$common/utils/curl/browser-curl';
import UrlModules from '$common/utils/curl/browser-curl/url-modules';
import AppCurl from '$common/utils/curl/app-curl';

export const gatewayWeb = 'gateway_web';
export const fileWeb = 'file_web';

const appgatewayHost = new UrlModules({ module: 'appgateway' });
const defaultCurl = (params, url, config) => new Curl().curl(params, `${appgatewayHost.host}/${gatewayWeb}/${url}`, config);
const defaultAppCurl = (params, url, config) => new AppCurl().curl(params, `/${url}`, config);

//  封装统一的请求
export const curlGateWay = (params, url, config) => ($vm?.$root?.isWownowApp) ? defaultAppCurl(params, url, config) : defaultCurl(params, url, config);

/**
 * 门店信息
 */
// export const getStoreInfo = (params, config) => defaultCurl(params, `digitalMenu/api/store/get-store-info`, config)
export const getStoreInfo = (params, config) => defaultCurl(params, `takeaway-merchant/app/super-app/get`, config)

/**
 * 菜单
 */
// export const getStoreInfo = (params, config) => defaultCurl(params, `digitalMenu/api/store/get-store-info`, config)
export const getMenuList = (params, config) => defaultCurl(params, `takeaway-product/app/user/menu`, config)

/**
 * 产品
 */
// export const getStoreInfo = (params, config) => defaultCurl(params, `digitalMenu/api/store/get-store-info`, config)
export const getProductList = (params, config) => defaultCurl(params, `takeaway-product/app/user/product/list`, config)
